<template>
  <div class="conditions-container">
    <div class="condition-panel">
      <div class="condition-item">
        <label class="item-title">院校名称:</label>
        <div class="area-item last-item">
          <input
            type="text"
            class="item-text"
            v-model.trim="artSchool.yxmc"
            autocomplete="off"
            placeholder="搜索院校名称"
          />
        </div>
      </div>
      <div class="condition-item">
        <label class="item-title">所在省份:</label>
        <div class="area-item">
          <span
            class="item-name"
            v-for="(yxdq, index) in yxdq"
            :key="index"
            :class="{ 'current-item': yxdq.isActive }"
            @click="checkItem('yxdq', yxdq, index)"
            >{{ yxdq.name }}</span
          >
        </div>
      </div>
      <div class="condition-item">
        <label class="item-title">批次类型:</label>
        <div class="area-item">
          <span
            class="item-name"
            v-for="(pcType, index) in pcType"
            :key="index"
            :class="{
              'current-item': pcType.isActive,
              'current-item-two':
                $route.path === '/main/yshSchoolRecommend' && !pcType.isPxz,
              'current-item-three':
                $route.path === '/main/yshSchoolRecommend' && pcType.value === 0,
                'current-item-four':
                $route.path==='/main/yshSchoolFinder'&&pcType.isHidden
            }"
            @click="checkItem('pcType', pcType, index)"
            >{{ pcType.name }}</span
          >
        </div>
      </div>
      <div class="condition-item">
        <label class="item-title">成绩类型:</label>
        <div class="area-item">
          <span
            class="item-name"
            v-for="(rkcj, index) in rkcj"
            :key="index"
            :class="{
              'current-item': rkcj.isActive,
              'current-item-two':
                $route.path === '/schoolRecommend' && index === 1
            }"
            @click="checkItem('rkcj', rkcj, index)"
            >{{ rkcj.name }}</span
          >
        </div>
      </div>
      <div class="condition-item">
        <label class="item-title">院校类型:</label>
        <div class="area-item">
          <span
            class="item-name"
            v-for="(yxType, index) in yxType"
            :key="index"
            :class="{ 'current-item': yxType.isActive }"
            @click="checkItem('yxType', yxType, index)"
            >{{ yxType.name }}</span
          >
        </div>
      </div>
      <div class="condition-item" v-if="$route.path === '/main/yshSchoolFinder'">
        <label class="item-title">再选科目:</label>
        <div class="area-item">
          <span
            class="item-name"
            v-for="(zxkm, index) in zxkms"
            :key="index"
            :class="{ 'current-item': zxkm.isActive }"
            @click="checkItem('zxkm', zxkm, index)"
            >{{ zxkm.name }}</span
          >
        </div>
      </div>
    </div>
    <div class="condition-btn">
      <!-- 
         -->
      <el-button
        type="primary"
        size="small"
        @click="querySchool"
        style="width:200px;font-size:16px"
        v-if="$route.path === '/main/yshSchoolFinder'"
        >开始查询</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="querySchool"
        style="width:200px;font-size:16px"
        v-else
        >开始推荐</el-button>
    </div>
    <div
      class="school-count"
      v-if="schoolData.data && schoolData.data.records.length > 0"
    >
      每页{{ schoolData.data.size }}条，共找到{{
        schoolData.data.total
      }}条记录
    </div>
    <!--       v-loading="loading"
      element-loading-text="正在加载中" -->
    <div
      style="max-width:1100px;margin:20px auto;min-height:100px"
      ref="yxcxRef"
    >
      <div class="condition-type" v-if="$route.path === '/main/yshSchoolRecommend'">
        <div
          class="type-item"
          v-for="(tier, index) in type"
          :key="index"
          :class="{ active: tier.isActive }"
          @click="checkItem('tier-type', tier, index)"
        >
          <span>{{ tier.name }}</span>
        </div>
      </div>
      <Schools-data-cx-vue
        v-if="schoolData.data && schoolData.data.records.length > 0"
        :istype="flag"
      />
      <div
        class="remarks"
        v-if="schoolData.data && schoolData.data.records.length === 0"
      >
        暂无符合条件的院校
      </div>
      <div
        class="pagination"
        :class="{'pagenation-other':artSchool.condition===2}"
        v-if="schoolData.data && schoolData.data.records.length > 0"
      >
        <el-pagination
          background
          v-if="schoolData.data"
          layout="prev, pager, next,total"
          :total="schoolData.data.total"
          :page-size="schoolData.data.size"
          :current-page="schoolData.data.current"
          @current-change="handleClickPage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SchoolsDataCxVue from './SchoolsData-cx.vue';
export default {
  name: "Conditions",
  props: ["conditionsExt", "artSchool", "tempZxkm"],
  data() {
    return {
      yxdq: this.conditionsExt.yxdq,
      pcType: this.conditionsExt.pcType,
      rkcj: this.conditionsExt.rkcj,
      yxType: this.conditionsExt.yxType,
      type: this.conditionsExt.type,
      zxkms: this.conditionsExt.zxkms,
      loading: false,
      loadingObj:{},
      flag: false,
      schoolDatas: {},
      checkedZxkms:[],
      artSchoolCondition:this.artSchool
    };
  },
  components: {
    SchoolsDataCxVue
  },
  computed: {
    ...mapState(["schoolData", "userInfo"])
  },
  watch: {
    userInfo() {
      this.artSchool.plan.sxkm = this.userInfo.sxkm;
    },
    $route(to, from) {
      console.log(to,from);
      if (
        (to.path === "/main/yshSchoolRecommend" || to.path === "/main/yshSchoolFinder") &&
        (from.path === "/main/yshSchoolRecommend" || from.path === "/main/yshSchoolFinder")
      ) {
        this.$store.dispatch("RestSchoolData");
        this._innerMap(this.conditionsExt.yxdq);
        this._innerMap(this.conditionsExt.pcType);
        this._innerMap(this.conditionsExt.rkcj);
        this._innerMap(this.conditionsExt.yxType);
        this._innerMap(this.conditionsExt.type);
        this._innerMap(this.conditionsExt.zxkms);
        this.artSchools = {
          pageNum: 1,
          items: [], //院校属地
          plan: { sxkm: this.userInfo.sxkm, lkxk: 0 },
          yxmc: "", //院校名称
          type: "",
        };
        this.tempZxkm = []
        this.reload();
      }
      if (to.path === "/main/yshSchoolRecommend" && this.artSchools.type === "") {
        this.artSchools.type = 1;
        this._initPc();
      } else if (to.path === "/main/yshSchoolFinder" && this.artSchools.type === "") {
        this.artSchools.type = 0;
        this._innerMap(this.conditionsExt.pcType);
        delete this.artSchools.condition;
      }
      if (to.path === "/main/yshSchoolRecommend") {
        this.$refs.son.flag = false;
        this._initPc();
      } else if (to.path === "/main/yshSchoolFinder") {
        this.artSchools.type = 0;
      }
    }
  },
  methods: {
    _innerMap(item) {
      item.map((innerItem, index) => {
        if (index === 0) {
          innerItem.isActive = true;
        } else {
          innerItem.isActive = false;
        }
      });
    },
    //根据用户注册显示可选科类
    _switchKlAndpcType() {
      if (this.userInfo) {
        this.artSchool.plan.sxkm = this.userInfo.sxkm;
        this.artSchool.plan.lkxk = 0;
        // this.artSchool.sfpxz=3;
        // const pcType=this.conditionsExt.pcType;
        // console.log(pcType);
        // delete this.artSchool.condition
      }
    },
    //分页
    handleClickPage(pageNum) {
      // this.loading = true;
      const loading = this.$loading({fullScreen:true,target:this.$refs.yxcxRef,text:"正在加载中"});
      this.loadingObj=loading;
      this.artSchool.pageNum = pageNum;
      this.$store.dispatch("getSchoolQuery", {
        artSchool: this.artSchool,
        callback: () => {
          // this.loading = false;
          loading.close();
        }
      });
    },
    //切换样式
    checkItem(item, data, index) {
      switch (item) {
        case "yxdq":
          if (index === 0) {
            //1.选中不限时，取消全部选中，并清空属地值
            this._innerMap(this.yxdq);
            this.artSchool.items = [];
          } else if (index !== 0 && data.isActive) {
            //2.点击不限之外的选项，并且已经选中的取消选中
            this.$set(data, "isActive", false);
            this.artSchool.items = this.artSchool.items.filter(province => {
              return province !== data.value;
            });
            //取消选中时候，判断如果全部取消了，就默认选中第一个
            if (this.artSchool.items.length === 0) {
              this._innerMap(this.yxdq);
            }
          } else {
            //3.如果选中的不是不限，取消默认不限样式，并且是第一次选中进行赋值操作
            this.yxdq.map((innerItem, index) => {
              if (index === 0) {
                innerItem.isActive = false;
              }
            });
            this.$set(data, "isActive", true);
            this.artSchool.items.push(data.value);
          }
          break;

        case "yxType":
          if (index === 0) {
            //1.选中不限时，取消全部选中，并清空值
            this._innerMap(this.yxType);
            delete this.artSchool.sf985;
            delete this.artSchool.sf211;
            delete this.artSchool.sfgb;
            delete this.artSchool.sfmb;
          } else if (index !== 0 && data.isActive) {
            //2.点击不限之外的选项，并且已经选中的取消选中
            this.$set(data, "isActive", false);
            delete this.artSchool[data.alias];
          } else {
            //3.如果选中的不是不限，取消默认不限样式，并且是第一次选中进行赋值操作
            this.yxType.map((innerItem, index) => {
              if (index === 0) {
                innerItem.isActive = false;
              }
            });
            this.$set(data, "isActive", true);
            this.artSchool[data.alias] = data.value;
          }
          //取消选中时候，判断如果全部取消了，就默认选中第一个
          let xlccArr = [];
          this.yxType.map((inneritem, index) => {
            if (inneritem.isActive) {
              xlccArr.push(inneritem);
            }
          });
          if (xlccArr.length === 0) {
            this._innerMap(this.yxType);
          }
          break;
        case "rkcj":
          if (index === 0 && item.name === "联考成绩") {
            //1.选中不限时，取消全部选中，并清空值
            this.flag = false;
            this._innerMap(this.rkcj);
            this.artSchool.plan.lkxk = item.value;
          } else if (index !== 0 && data.isActive) {
            //2.点击不限之外的选项，并且已经选中的取消选中
            this.$store.dispatch("RestSchoolData");
            this.$set(data, "isActive", false);
            this.artSchool.plan.lkxk = 0;
            this._innerMap(this.rkcj);
            this.pcType.map((pcType, i) => {
              if (i === 0) {
                this.flag = false;
                pcType.isActive = true;
                delete this.artSchool.condition;
              } else {
                pcType.isActive = false;
              }
            });
          } else {
            //3.如果选中的不是不限，取消默认不限样式，并且是第一次选中进行赋值操作
            this.rkcj.map((innerItem, index) => {
              innerItem.isActive = false;
            });
            this.$set(data, "isActive", true);
            this.artSchool.plan.lkxk = data.value;
          }
          break;
        case "pcType":
          if (index === 0) {
            //1.选中不限时，取消全部选中，并清空值
            this.flag = false;
            this.$store.dispatch("RestSchoolData");
            this._innerMap(this.pcType);
            delete this.artSchool.condition;
            this.rkcj.map((rkcj, i) => {
              if (i === index) {
                rkcj.isActive = true;
                this.artSchool.plan.lkxk = rkcj.value;
              } else {
                rkcj.isActive = false;
              }
            });
            // this.artSchool.condition = data.value;
          } else if (index !== 0 && data.isActive) {
            //2.点击不限之外的选项，并且已经选中的取消选中
            this.flag = false;
            this.$set(data, "isActive", false);
            delete this.artSchool.condition;
            this._innerMap(this.pcType);
          } else if (index === 1 && data.alias == "pc-type1") {
            //如果选中的是第一项，认可成绩跟着联动
            this.flag = true;
            this.$store.dispatch("RestSchoolData");
            this.pcType.map((innerItem, index) => {
              innerItem.isActive = false;
            });
            this.$set(data, "isActive", true);
            this.artSchool.condition = data.value;
          } else {
            this.flag = false;
            this.$store.dispatch("RestSchoolData");
            //3.如果选中的不是不限，取消默认不限样式，并且是第一次选中进行赋值操作
            this.pcType.map((innerItem, index) => {
              innerItem.isActive = false;
            });
            this.$set(data, "isActive", true);
            this.artSchool.condition = data.value;
          }
          break;
        case "tier-type":
          if (!data.isActive) {
            this.type.map((innerItem, index) => {
              innerItem.isActive = false;
            });
            this.$set(data, "isActive", true);
            this.artSchool.type = data.value;
            this.querySchool();
          }
          break;
        case "zxkm":
          if(data.isActive && index !== 0 ){
            let tempArr = [];
            this.$set(data, 'isActive', false);
            this.checkedZxkms.map(v => {
                if(v !== data.value) {
                    tempArr.push(v)
                }
            })
            this.checkedZxkms = tempArr;
            if(this.checkedZxkms.length === 0) {this.zxkms[0].isActive = true;}
        }else if(index === 0){
            this._innerMap(this.zxkms);
            this.checkedZxkms = [];
        }else{
            this.$set(data, 'isActive', true);
            this.checkedZxkms.push(data.value);
            this.zxkms[0].isActive = false;
        } 
        let str = ""
        this.checkedZxkms.map(v => {
            str += v + '|'
        });
        let str1 = str.substr(0, str.length-1);
        this.artSchool.plan.zxkmyq = str1;
        break;
      }
    },
    async querySchool() {
      this.artSchool.pageNum = 1;
      // this.loading = true;
      const loading = this.$loading({fullScreen:true,target:this.$refs.yxcxRef,text:"正在加载中"});
      await this.$store.dispatch("getSchoolQuery", {
        artSchool: this.artSchoolCondition,
        callback: () => {
          // this.loading = false;
          loading.close();
        }
      });
      this.artSchoolCondition=this.artSchool;
    }
  },
  activated() {
    // 在院校推荐选择pc 直接退出后，下次登录pc条件仍热存在，所以要在这里删除一下
    if (this.$route.path === "/main/datahome"||this.$route.path=="/main/home"||
      this.$route.path=='/main/yshMajorQuery'||this.$route.path=='/main/yshSchoolRecommend'||
    this.$route.path=='/yshMe/updateScore'||this.$route.path=='/main/buyindex') {
      this._innerMap(this.pcType);
      //在院校推荐点击批次后，当点击院校查询时候删除已经存在的批次条件
      delete this.artSchool.condition;
    }

    // 当退出登录或者超时改变loading 动画
    if (this.userInfo&&this.userInfo.uid) {
      // this.loading = false;
    }
  },
  mounted() {
    this._switchKlAndpcType();
    this.checkedZxkms=this.tempZxkm;
  }
};
</script>

<style lang="stylus" scoped>
.pagination
        width 1100px
        margin 0 auto
        padding 10px 0 30px
        text-align center
        background-color #ffffff
.remarks
        width 1100px
        margin 0 auto
        margin-top 20px
        color #666
.condition-panel,.condition-type
        width 1100px
        box-sizing border-box
        margin 0 auto
        padding 16px
        background-color #ffffff
    .condition-panel
        border 1px solid #DCDFE6
        .condition-item
            display flex
            align-items center
            flex-direction row
            margin-bottom 10px
            .item-title
                display inline-block
                width 100px
                height 40px
                line-height 30px
                text-align right
                margin 0 5px
                font-size 14px
                font-weight 600
                color #606266
            .item-text
                box-sizing border-box
                width 500px
                height 30px
                padding-left 10px
                outline none
                border 1px solid #DCDFE6
                transition all 0.5s
                color #606266
                &:focus
                    border 1px solid #409EFF
                    box-shadow 0 0 3px #409EFF
            .area-item
                width 1000px
                box-sizing border-box
                margin-left 10px
                padding-bottom 8px
                font-size 13px
                color #2c3e50
                border-bottom 1px dashed #E4E7ED
                .item-name
                    display inline-block
                    padding 3px 10px
                    margin 2px 5px
                    border-radius 3px
                    cursor pointer
                    &:hover
                        background-color #409EFF
                        color #ffffff
                .current-item
                    background-color #409EFF
                    color #ffffff
                .current-item-two,.current-item-three,.current-item-four
                    display none
            .last-item
                border none
                padding-bottom 0
                label
                    display inline-block
                    width 100px
                    height 40px
                    line-height 32px
                    text-align right
                    color #515a6e
                    margin-right 5px
    .condition-btn
        display flex
        align-items center
        justify-content center
        margin 20px 0 0
    .school-count
        box-sizing border-box
        width 1100px
        margin 0 auto
        padding 16px
        color rgb(64, 158, 255)
    .condition-type
        .type-item
            display inline-block
            width 160px
            height 50px
            line-height 50px
            text-align center
            font-size 18px
            color #909399
            border 1px solid #ccc
            border-left none
            cursor pointer
            &:first-child
                border-left 1px solid #ccc
        .active
            background-color #f39800
            color #fff
</style>
<style scoped>
.pagenation-other{
width: 980px;
}
</style>
